import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "./insa-services";

import {
  EmbeddedLoginComponent,
  LoginComponent,
  ChangePasswordComponent,
  RegisterComponent,
} from "./insa-components/insa-login";
import { HomeComponent } from "./insa-components/insa-home";
import {
  DonutChartsComponent,
  PerformanceComponent,
  SecurityPricesComponent,
} from "./insa-components/insa-charts";
import { NewsComponent } from "./insa-components/insa-news";
import {
  InsaMainWindowComponent,
  NewHomeComponent,
} from "./insa-components/insa-main";
import {
  TransactionsComponent,
  PortfolioComponent,
  CrossRatesComponent,
  ClientContactComponent,
  LoginStatsComponent,
  EmailMapperComponent,
} from "./insa-components/insa-grids";
import { ReportComponent } from "./insa-report";
import { DashboardComponent } from "./insa-pivot";
import { RiskAssessmentComponent } from "./insa-components/insa-risk-assessment";
import { GenericFormComponent } from "./insa-components/insa-generic-form";
import {
  InsaCronComponent,
  JobLogComponent,
  InsaTaskListComponent,
  ChronosJobListComponent,
} from "./insa-components/insa-cron";
import { VideoCallClientComponent } from "./insa-components/insa-login/video-call/video-call-client.component";
import { VideoCallManagerComponent } from "./insa-components/insa-login/video-call/video-call-manager.component";
import { ExampleFormComponent } from "./insa-components/insa-generic-form/example-form.component";
import { StandaloneFilePickerExample } from "./insa-components/insa-generic-form/standalone-file-picker-example.component";
import { InsaTraderComponent } from "./insa-components/insa-trader/insa-trader.component";

export const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "changePassword", component: ChangePasswordComponent },
  { path: "login", component: LoginComponent, canActivate: [AuthGuard] },
  {
    path: "embeddedLogin",
    component: EmbeddedLoginComponent,
    canActivate: [AuthGuard],
  },
  { path: "register", component: RegisterComponent },
  { path: "newHome", component: NewHomeComponent },
  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "charts", component: DonutChartsComponent, canActivate: [AuthGuard] },
  {
    path: "performance",
    component: PerformanceComponent,
    canActivate: [AuthGuard],
  },
  { path: "news", component: NewsComponent, canActivate: [AuthGuard] },
  {
    path: "insamainwindow",
    component: InsaMainWindowComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "transactions",
    component: TransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "portfolio",
    component: PortfolioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "crossRates",
    component: CrossRatesComponent,
    canActivate: [AuthGuard],
  },
  { path: "report", component: ReportComponent, canActivate: [AuthGuard] },
  {
    path: "security",
    component: SecurityPricesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "clientContact",
    component: ClientContactComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "riskAssessment",
    component: RiskAssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "genericForms/:metadataName/:id",
    component: GenericFormComponent,
    canActivate: [AuthGuard],
    pathMatch: "full",
  },
  {
    path: "genericForms/:metadataName",
    component: GenericFormComponent,
    canActivate: [AuthGuard],
    pathMatch: "full",
  },
  {
    path: "genericForms",
    component: GenericFormComponent,
    canActivate: [AuthGuard],
    pathMatch: "full",
  },
  {
    path: "insaTrader",
    component: InsaTraderComponent,
    canActivate: [AuthGuard],
    pathMatch: "full",
  },
  {
    path: "insaChronos",
    component: InsaCronComponent,
    children: [
      //{ path: '', redirectTo: '/insaChronos/chronosJobList', pathMatch: 'full' },
      { path: "", redirectTo: "chronosJobList", pathMatch: "full" },
      { path: "chronosJobList", component: ChronosJobListComponent },
      { path: "chronosJobLog", component: JobLogComponent },
      { path: "taskList", component: InsaTaskListComponent },
      //{ path: '**', redirectTo: '/insaChronos/chronosJobList', pathMatch:'full'}
      { path: "**", redirectTo: "chronosJobList", pathMatch: "full" },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: "loginstats",
    component: LoginStatsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "emailMapper",
    component: EmailMapperComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "video-client",
    component: VideoCallClientComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "video-manager",
    component: VideoCallManagerComponent,
    canActivate: [AuthGuard],
  },
  { path: "exampleForm", component: ExampleFormComponent },
  { path: "standaloneFilePicker", component: StandaloneFilePickerExample },
  { path: "**", redirectTo: "/home", pathMatch: "full" },
];
/* tile visibility*/
export const routesWithoutTiles: any = [
  "/dashboard",
  "/report",
  "/riskAssessment",
  "/embeddedLogin",
  "/security",
  "/insamainwindow",
  "/insaChronos",
  "/insaChronos/chronosJob",
  "/insaChronos/chronosJobLog",
  "/insaChronos/taskList",
  "/insaTrader",
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: true, useHash: true }),
  ],
  providers: [AuthGuard],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./app/app-routing.module.ts